module.exports = __webpack_public_path__ + "img/tit-video.2f3de99a.png";